/*  PÉNZNEMEK A TANÓRÁN KÍVÜLI TEVÉKENYSÉGEKHEZ.
 *
 *  A jelentkezős események ára eddig csak forintban volt megadható, miközben pl. a
 *  külföldi sítábor euróban fizetendő. A lista szándékosan rövid és zárt: a kiszolgáló
 *  ugyanezt fogadja el (backend/tkt-befizetes.js › PENZNEMEK), mert a részletek
 *  összeadásánál a pénznemnek egyeznie kell.
 */
export interface Penznem {
  kod: string;
  jel: string;
  nev: string;
}

export const PENZNEMEK: Penznem[] = [
  { kod: 'HUF', jel: 'Ft', nev: 'Forint' },
  { kod: 'EUR', jel: '€', nev: 'Euró' },
  { kod: 'USD', jel: 'USD', nev: 'Amerikai dollár' },
];

/** A pénznem kódja; ismeretlen vagy üres = forint (a régi események jelentése). */
export function penznemKod(kod: any): string {
  const k = String(kod || '').trim().toUpperCase();
  return PENZNEMEK.some((p) => p.kod === k) ? k : 'HUF';
}

export function penznemJel(kod: any): string {
  const k = penznemKod(kod);
  return PENZNEMEK.find((p) => p.kod === k)?.jel || 'Ft';
}

/**
 *  Összeg a pénznemével, magyar írásmóddal: „7 000 Ft", „450 €", „1 250,50 €".
 *  Üres összegnél üres szöveg – a hívó dönti el, kiírja-e egyáltalán.
 */
export function osszegSzoveg(osszeg: any, kod: any): string {
  if (osszeg === null || osszeg === undefined || osszeg === '') return '';
  const szam = Number(osszeg);
  if (!Number.isFinite(szam)) return '';
  return `${szam.toLocaleString('hu-HU', { maximumFractionDigits: 2 })} ${penznemJel(kod)}`;
}
